import { render, staticRenderFns } from "./FormWizardStep.vue?vue&type=template&id=1850afd3&"
import script from "./FormWizardStep.ts?vue&type=script&lang=ts&"
export * from "./FormWizardStep.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports